export default {"src":"/_next/static/media/glass-2.975ee472.svg","height":797,"width":954,"blurWidth":0,"blurHeight":0};